// 【公共組件】本地/雲端流程切換
export default {
    'toggleProcess.tips1': '當前檢測到無網狀態，請聯網後再操作！',
    'toggleProcess.tips2': '沒有獲取到本地的域名，請確認當前連接的wifi是配網的wifi。' ,
    'toggleProcess.tips3': '請問確認要切換版本嗎？請注意不同的版本展示的頁面會不相同。' 
}
 